import Vue from 'vue';
import VueRouter from 'vue-router';
import routes from './routes';
import axios from 'axios';
import {apiRoutes} from '../apiRoutes'
import {authHeader} from '../global'

Vue.use(VueRouter);

// configure router
const router = createRouter()

/**
 * Create a new router instance.
 */
 function createRouter() {
  const router = new VueRouter({
      mode: 'history',
      linkActiveClass: 'active',
      routes: routes,
      scrollBehavior: (to, from ,savedPosition) => {
        if (savedPosition) {
          return savedPosition;
        }
        if (to.hash) {
          return { selector: to.hash };
        }
        return { x: 0, y: 0 };
      }
  })

  // Check user authentication before route to requested page
  router.beforeEach(beforeEach)

  //router.afterEach(afterEach)

  return router
}

async function beforeEach(to, from, next) {
  // Get the matched components and resolve them
  if (to.meta.requireAuth) {
    let access_token = localStorage.getItem("access_token")
    if(access_token) {
      let isValid = await isValidAcess(access_token);
      if(isValid)
      {
        next();
      }
      else {
        if(to.path != '/login')
          next("/login");
      }

      next()
    }
    else {
      next("/login");
    }
  }
  else {
    next();
  }

}

async function isValidAcess(){
  let isValid = 0
  await axios.post(`${apiRoutes['IS_VALID_ACESS_TOKEN']}`, {}, authHeader())
            .then(response => {
                if(response.data.code == 1){
                   isValid = 1
                }
            })
            .catch(error => {
                if (error.response) {
                    Vue.notify({
                        group: 'notify',
                        type: 'error',
                        text: "User has no access!",
                        max: 5,
                        duration: 5000,
                        speed: 300
                    })
                } else {
                    console.log("Problem with access", error);
                }
            });

  return isValid
}

export default router;
